export enum DischargeTypes {
  LOAD_REQUEST = "@discharge/LOAD_REQUEST",
  LOAD_SUCCESS = "@discharge/LOAD_SUCCESS",
  LOAD_FAILURE = "@discharge/LOAD_FAILURE",

  SUBMIT_REQUEST = "@discharge/SUBMIT_REQUEST",
  SUBMIT_SUCCESS = "@discharge/SUBMIT_SUCCESS",
  SUBMIT_FAILURE = "@discharge/SUBMIT_FAILURE",

  LOAD_REASONS_REQUEST = "@discharge/LOAD_REASONS_REQUEST",
  LOAD_REASONS_SUCCESS = "@discharge/LOAD_REASONS_SUCCESS",
  LOAD_REASONS_FAILURE = "@discharge/LOAD_REASONS_FAILURE",
}

export interface DischargeState {
  data: DischargeViewItem | null;
  loading: boolean;
  success: boolean;
  error: boolean;

  reasons: DischargeReasonItem[];
  reasonsLoading: boolean;
}

export interface DischargeReasonItem {
  id: string;
  describe: string;
}

export interface DischargeInfosResponse {
  reasons: DischargeReasonItem[];
  main_diagnosis: {
    id: string;
    describe: string;
  };
  attendance_provider: {
    id: string;
    name: string;
  };
}

export interface DischargeSubmitPayload {
  external_company_id: string;
  external_attendance_id: string;
  external_patient_id: string;
  discharge: {
    external_reason: {
      id: string;
      describe: string;
    };
    observations: string;
  };
  created_by: string;
}

export interface DischargeViewItem {
  attendance_provider_name: string;
  external_company_id: string;
  external_attendance_id: string;
  external_patient_id: string;
  diagnosis: string;
  discharge_date: string;
}
